export const ALPHA_LAYOUT_HEADER_ID = 'ALPHA_LAYOUT_HEADER_ID';
export const ALPHA_LAYOUT_MAIN_ID = 'ALPHA_LAYOUT_MAIN_ID';
export const ALPHA_LAYOUT_NAVBAR_ID = 'ALPHA_LAYOUT_NAVBAR_ID';
